import { Link } from "react-router-dom";
import type { CategoryProduct } from "@/lib/catalog";
import ProductItemCard from "@/components/feature/ProductItemCard";

const CARD_WIDTH = "w-[78%] shrink-0 snap-center sm:w-[46%] lg:w-[30%]";

function CarouselSkeleton() {
  return (
    <div className="mt-4 flex gap-4 overflow-hidden px-4 md:px-6">
      {Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className={CARD_WIDTH}>
          <div className="aspect-square w-full animate-pulse rounded-lg bg-background-100" />
          <div className="mt-3 h-3 w-3/4 animate-pulse rounded bg-background-200" />
          <div className="mt-2 h-3 w-1/3 animate-pulse rounded bg-background-200" />
        </div>
      ))}
    </div>
  );
}

interface ProductCarouselProps {
  title: string;
  products: CategoryProduct[];
  loading?: boolean;
  to?: string;
}

export default function ProductCarousel({
  title,
  products,
  loading = false,
  to,
}: ProductCarouselProps) {
  // Nunca mostrar datos de prueba: si no hay anuncios reales, no se renderiza.
  if (!loading && products.length === 0) return null;

  return (
    <section className="py-5">
      <div className="flex items-center justify-between px-4 md:px-6">
        <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
          {title}
        </h2>
        {to && products.length > 0 && (
          <Link
            to={to}
            className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-500 hover:text-primary-600"
          >
            Ver todo <i className="ri-arrow-right-line"></i>
          </Link>
        )}
      </div>

      {loading ? (
        <CarouselSkeleton />
      ) : (
        <div
          data-product-shop
          className="no-scrollbar mt-4 flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-px-4 px-4 md:px-6"
        >
          {products.map((product) => (
            <div key={product.id} className={CARD_WIDTH}>
              <ProductItemCard product={product} />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}